<div class="content">
  <div class="configurationBannerHeader" (click)="toggleExpansion()">
    <label class="configurationBannerLabel">Unit Information</label>
    <span class="spacer"></span>
    <mat-icon class="expansionIcon">{{ getExpansionIcon() }}</mat-icon>
  </div>
  @if (isExpanded) {
    <div class="detail">
      <div class="configurationOptions">
        <div class="configurationDetailRow">
          @if (modelSelection) {
            <span class="fullWidthConfigurationInput">
              <label class="halfWidthInputLabel">Model:</label>
              <select class="halfWidthInputField" #modelInput
                [class.invalidConfigurationSelection]="isInvalidSelection(modelSelection.Name)"
                (change)="selectionChanged(modelSelection, modelInput.value)"
                [value]="modelSelection.Value.toString()">
                @for (allowable of modelSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="modelSelection.Value && modelSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">{{ allowable.Description }}</option>
                }
              </select>
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (configurationSelection) {
            <span class="fullWidthConfigurationInput">
              <label class="halfWidthInputLabel">Configuration:</label>
              <select class="halfWidthInputField" #configurationInput
                [class.invalidConfigurationSelection]="isInvalidSelection(configurationSelection.Name)"
                (change)="selectionChanged(configurationSelection, configurationInput.value)"
                [value]="configurationSelection.Value.toString()">
                @for (allowable of configurationSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="configurationSelection.Value && configurationSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">{{ allowable.Description }}</option>
                }
              </select>
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (sizeSelection) {
            <span class="fullWidthConfigurationInput">
              <label class="halfWidthInputLabel">Size:</label>
              <select class="halfWidthInputField" #sizeInput
                [class.invalidConfigurationSelection]="isInvalidSelection(sizeSelection.Name)"
                (change)="selectionChanged(sizeSelection, sizeInput.value)"
                [value]="sizeSelection.Value.toString()">
                @for (allowable of sizeSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="sizeSelection.Value && sizeSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">{{ allowable.Description }}</option>
                }
              </select>
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (returnAirSelection) {
            <span class="fullWidthConfigurationInput">
              <label class="halfWidthInputLabel">Return Air:</label>
              <select class="halfWidthInputField" #returnAirInput
                [class.invalidConfigurationSelection]="isInvalidSelection(returnAirSelection.Name)"
                (change)="selectionChanged(returnAirSelection, returnAirInput.value)"
                [value]="returnAirSelection.Value.toString()">
                @for (allowable of returnAirSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="returnAirSelection.Value && returnAirSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">{{ allowable.Description }}</option>
                }
              </select>
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (unitVoltageSelection) {
            <span class="fullWidthConfigurationInput">
              <label class="halfWidthInputLabel">Voltage:</label>
              <select class="halfWidthInputField" #unitVoltageInput
                [class.invalidConfigurationSelection]="isInvalidSelection(unitVoltageSelection.Name)"
                (change)="selectionChanged(unitVoltageSelection, unitVoltageInput.value)"
                [value]="unitVoltageSelection.Value.toString()">
                @for (allowable of unitVoltageSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="unitVoltageSelection.Value && unitVoltageSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">{{ allowable.Description }}</option>
                }
              </select>
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (controlsSelection) {
            <span class="fullWidthConfigurationInput">
              <label class="halfWidthInputLabel">Controls:</label>
              <select class="halfWidthInputField" #controlsInput
                [class.invalidConfigurationSelection]="isInvalidSelection(controlsSelection.Name)"
                (change)="selectionChanged(controlsSelection, controlsInput.value)"
                [value]="controlsSelection.Value.toString()">
                @for (allowable of controlsSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="controlsSelection.Value && controlsSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">{{ allowable.Description }}</option>
                }
              </select>
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (cabinetInsulationSelection) {
            <span class="fullWidthConfigurationInput">
              <label class="halfWidthInputLabel">Cabinet Insulation:</label>
              <select class="halfWidthInputField" #cabinetInsulationInput
                [class.invalidConfigurationSelection]="isInvalidSelection(cabinetInsulationSelection.Name)"
                (change)="selectionChanged(cabinetInsulationSelection, cabinetInsulationInput.value)"
                [value]="cabinetInsulationSelection.Value.toString()">
                @for (allowable of cabinetInsulationSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="cabinetInsulationSelection.Value && cabinetInsulationSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">{{ allowable.Description }}</option>
                }
              </select>
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (waterCircuitSelection) {
            <span class="fullWidthConfigurationInput">
              <label class="halfWidthInputLabel">Water Circuit:</label>
              <select class="halfWidthInputField" #waterCircuitInput
                [class.invalidConfigurationSelection]="isInvalidSelection(waterCircuitSelection.Name)"
                (change)="selectionChanged(waterCircuitSelection, waterCircuitInput.value)"
                [value]="waterCircuitSelection.Value.toString()">
                @for (allowable of waterCircuitSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="waterCircuitSelection.Value && waterCircuitSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">{{ allowable.Description }}</option>
                }
              </select>
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (heatExchangerOptionsSelection) {
            <span class="fullWidthConfigurationInput">
              <label class="halfWidthInputLabel">Heat Exchanger Options:</label>
              <select class="halfWidthInputField" #heatExchangerOptionsInput
                [class.invalidConfigurationSelection]="isInvalidSelection(heatExchangerOptionsSelection.Name)"
                (change)="selectionChanged(heatExchangerOptionsSelection, heatExchangerOptionsInput.value)"
                [value]="heatExchangerOptionsSelection.Value.toString()">
                @for (allowable of heatExchangerOptionsSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="heatExchangerOptionsSelection.Value && heatExchangerOptionsSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">{{ allowable.Description }}</option>
                }
              </select>
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (optionsSelection) {
            <span class="fullWidthConfigurationInput">
              <label class="halfWidthInputLabel">Options:</label>
              <select class="halfWidthInputField" #optionsInput
                [class.invalidConfigurationSelection]="isInvalidSelection(optionsSelection.Name)"
                (change)="selectionChanged(optionsSelection, optionsInput.value)"
                [value]="optionsSelection.Value.toString()">
                @for (allowable of optionsSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="optionsSelection.Value && optionsSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">{{ allowable.Description }}</option>
                }
              </select>
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (blowerMotorSelection) {
            <span class="fullWidthConfigurationInput">
              <label class="halfWidthInputLabel">Blower Drive Package:</label>
              <select class="halfWidthInputField" #blowerMotorInput
                [class.invalidConfigurationSelection]="isInvalidSelection(blowerMotorSelection.Name)"
                (change)="selectionChanged(blowerMotorSelection, blowerMotorInput.value)"
                [value]="blowerMotorSelection.Value.toString()">
                @for (allowable of blowerMotorSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="blowerMotorSelection.Value && blowerMotorSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">{{ allowable.Description }}</option>
                }
              </select>
            </span>
          }
        </div>
      </div>
      @if (isHandArrangementImageAvailable()) {
        <div class="arrangementImage">
          <img class="detailImage" [src]="handArrangementImagePath()" alt="ArrangementImage" width="290" height="260"/>
        </div>
      }
    </div>
  }
</div>
